// eslint-disable-next-line import/no-extraneous-dependencies
import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey('7afd50095c9a3b4ee250c7ec2d489450Tz05NjQ0MixFPTE3NTU2ODU1NjMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==');